/* Block Badge — .tedi-block-badge
   Adapted from .ex-code in tedi__site, computed values hardcoded */

.tedi-block-badge {
    font-family: var(--t3di__font-family-mono, 'SF Mono', Monaco, Consolas, monospace);
    font-size: 0.875em;
    color: hsl(72, 0%, 90%);
    padding: 0.375em 0.6em 0.375em 0.575em;
    display: inline-flex;
    letter-spacing: 0.0675em;
    justify-content: center;
    text-align: center;
    line-height: 1.2;
    transform: translateX(-0.25em) translateY(-0.0675em);
    border: 1px solid var(--t3di__layer-2);
    text-shadow:
        0 0 0.125em hsla(72, 90%, 75%, 0.05),
        0 0 0.25em hsla(72, 90%, 75%, 0.14),
        0 0 0.5em hsla(43, 95%, 75%, 0.14),
        1px 0.5px 0.0675em hsla(43, 95%, 75%, 0.14);
    background:
        linear-gradient(to bottom,
            transparent 30%,
            hsla(43, 95%, 70%, 0.25) 30% 50%,
            transparent 50% 70%,
            hsla(43, 95%, 70%, 0.25) 70% 90%,
            transparent 90%),
        linear-gradient(90deg,
            hsla(43, 95%, 70%, 0.18),
            hsla(43, 95%, 70%, 0.10) 50%,
            hsla(43, 95%, 70%, 0.14)),
        hsl(72, 22%, 11%);
    background-size: 100% 3px, 100% 100%, 100% 100%;
    border-radius: calc(var(--t3di__border-radius-sm) / 2);
    overflow: hidden;
    position: relative;
    box-shadow:
        0 0 0 0.0625em hsl(72, 11%, 32%),
        0 0.25em 0.75em -0.125em hsla(72, 28%, 9%, 0.2);
}
